module.exports = __webpack_public_path__ + "img/2021-WES-stack.d813504d.png";